import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ReportCommonService } from '../shared/services/report-common.service';

@Component({
  selector: 'save-filter-template',
  templateUrl: './save.component.html',
  styleUrls: ['./filtersdialog.component.scss']
})
export class SaveComponent {

  constructor(public commonData: ReportCommonService){}

  @ViewChild('popupModal') public modal:any;
  @Input() public saveDialogOpened: boolean=false;
  @Input() public templateName: string='';
  @Input() public templateId: number=0;
  @Output() public submitted = new EventEmitter();
  @Output() public canceled = new EventEmitter();
  @Output() public saveDialogOpenedChange = new EventEmitter();
  @Output() public templateNameChange = new EventEmitter();
  @Output() public templateIdChange = new EventEmitter();

  public saveDisabled: boolean = false;
  public templateNameRequired: boolean = false;
  public templateNameInUse: boolean = false;
  public reservedNames: string[] = ['custom', 'unfiltered'];

  public nameChanged(event:any){
    // compare to current template names and enable save button if
    // unique
    this.templateName = event.target.value.trimStart()
    this.saveDisabled = this.templateName === '' || this.reservedNames.includes(this.templateName.toLowerCase()) || this.commonData.SaveTemplateExists(this.templateName.trim(),this.templateId);
    this.templateNameInUse = (this.saveDisabled && (this.commonData.SaveTemplateExists(this.templateName.trim(),this.templateId) || this.reservedNames.includes(this.templateName.toLowerCase())));
    this.templateNameRequired = (this.templateName === '');
  }
  public clickSave(){
    this.submitted.emit(this.templateName.trim());
    this.saveDialogOpened = false;
  }
  public clickCancel(){
    this.canceled.emit();
    this.saveDialogOpened = false;
    this.templateName=this.commonData.GetOrgTemplateName(this.templateId);
    this.templateNameInUse=false;
    this.templateNameRequired=false;   
    this.saveDisabled=false;    
  }
  public close(){
    this.canceled.emit();
    this.saveDialogOpened = false;
    this.templateName=this.commonData.GetOrgTemplateName(this.templateId);
    this.templateNameInUse=false;
    this.templateNameRequired=false;   
    this.saveDisabled=false;
  }
  public open() {
    this.saveDialogOpened = true;
  }
}
